<template>
  <div class="equipmentShift pointer">
    <NavBar title="设备转移" />
    <div class="main">
      <div class="cardBox">
        <div class="card" @click="selecteQuipment">
          <p>选择云手机</p>
          <div class="no_equipment" v-show="equipmentList.length <= 0">
            暂未选择设备
          </div>
          <div class="no_equipment" v-show="equipmentList.length > 0">
            已选择<span class="sp1">{{ equipmentList.length }}</span
            >台设备
          </div>
          <img src="@/assets/icons/xuenze.png" alt="" />
        </div>
        <div class="equipmentDetails" v-if="equipmentList.length > 0">
          <div class="packUpBox" v-if="!unfoldShow">
            <div>
              <span class="deviceType">{{
                getDeviceType(
                  equipmentList[0].vipCode,
                  equipmentList[0].deviceVersionCode,
                  equipmentList[0].vipName
                )
              }}</span>
              {{ equipmentList[0].instanceName }}
            </div>
            <div class="viewAll" @click="unfoldShow = true">
              <div>查看全部</div>
              <img src="@/assets/icons/down_arrows.png" alt="" />
            </div>
          </div>
          <div class="unfoldBox" v-else>
            <div class="line"></div>
            <div
              class="unfoldItem"
              v-for="item in equipmentList"
              :key="item.id"
            >
              <span class="deviceType">{{
                getDeviceType(
                  item.vipCode,
                  item.deviceVersionCode,
                  item.vipName
                )
              }}</span>
              {{ item.instanceName }}
            </div>
            <div class="unfoldName" @click="unfoldShow = false">
              <div>收起</div>
              <img src="../../../assets/icons/unfoldName.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="sq_zh">
        <p>接收方</p>
        <van-cell-group class="phoneFrame">
          <van-field
            v-model="phone"
            type="tel"
            placeholder="请输入被转移用户手机号码"
            maxlength="11"
            class="inputBack"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="againPhone"
            type="tel"
            placeholder="再次输入被转移手机号确认"
            maxlength="11"
            class="inputBack"
          />
        </van-cell-group>
      </div>
      <div class="sq_zh">
        <div class="verificationBox">
          <p>
            <van-radio-group
              v-model="Switchlogin"
              direction="horizontal"
              icon-size="18"
            >
              <van-radio
                :name="false"
                label-position="left"
                checked-color="#8572eb"
                >密码验证</van-radio
              >
              <van-radio
                :name="true"
                label-position="left"
                checked-color="#8572eb"
                >短信验证</van-radio
              >
            </van-radio-group>
          </p>
          <van-cell-group v-if="Switchlogin">
            <van-field
              v-model="yanzhengma"
              placeholder="请输入验证码"
              maxlength="6"
              class="inputBack"
            >
              <template #button>
                <van-button
                  v-if="!yzm_daojishi"
                  size="small"
                  class="yzm_btn"
                  @click="getyanzhengma"
                  >获取验证码</van-button
                >
                <van-button
                  v-else
                  size="small"
                  class="yzm_btns"
                  :disabled="true"
                  >{{ countDown }}S重新发送</van-button
                >
              </template>
            </van-field>
          </van-cell-group>
          <van-cell-group v-else>
            <van-field
              v-model="password"
              :type="showornot"
              name="密码"
              placeholder="请输入密码"
              :rules="[{ required: true, message: '请填写密码' }]"
              class="inputBack"
            >
              <template #button>
                <span @click="isShow">
                  <van-icon name="closed-eye" v-if="showeye" />
                  <van-icon name="eye-o" v-else />
                </span>
              </template>
            </van-field>
          </van-cell-group>
        </div>
      </div>
      <div class="sq_zh">
        <van-checkbox
          v-model="checked"
          class="agreementBox"
          icon-size="16px"
          checked-color="#8572eb"
        >
          我已阅读并同意
          <a
            target="_blank"
            href="http://static.aixunliu.com/app/transfer_agreement.html"
            >《迅流云手机转移协议》</a
          >
        </van-checkbox>
      </div>
      <div class="sq_gz">
        <p class="gz_title">转移云手机规则</p>
        <div class="gz_particulars">
          <p>1.进行转移的云手机剩余时间需要大于24小时；</p>
          <p>
            2.转移为带数据转移，若需删除数据，请在转移前进行恢复出厂设置操作；
          </p>
          <p>3.处于维护状态的云手机需等维护结束后才可转移；</p>
          <p>4.每台云手机只能被转移一次，已转移的云手机无法再次转移；</p>
          <p>5.单次最多转移10台云手机；</p>
          <p>6.转移的是云手机整个设备而不是云手机里的部分时间；</p>
          <p>7.授权云手机无法转移，需先解除授权才能进行转移；</p>
          <p>
            8.转移操作一旦完成不可逆，不支持找回，转移前请确认转移账号信息准确，请谨慎操作；
          </p>
        </div>
      </div>
    </div>
    <div class="baseBox">
      <button class="qdsq_btn" @click="querenshouquan">确认转移</button>
    </div>
    <Loading v-model="showDialog" text="正在转移设备...">
      <!-- <div>中间内容</div> -->
    </Loading>
  </div>
</template>
  
  <script>
import { Toast } from "vant";
import { getsendCode } from "@/api/login";
import { userEquipmentTransfer } from "@/api/instance";
import NavBar from "@/components/NavBar.vue";
import Loading from "@/components/publicDialog/Loading.vue";
import { mapState, mapMutations } from "vuex";
import buyCode from "@/utils/buyCode";
export default {
  name: "EquipmentShift",
  components: {
    NavBar,
    Loading,
  },
  data() {
    return {
      checked: false,
      result: {},
      phone: "",
      againPhone: "",
      timer: null, // 定时器
      countDown: 60, // 倒计时时间
      yanzhengma: "",
      password: "",
      yzm_daojishi: false,
      userdata: {},
      active: 0,
      show: false,
      Switchlogin: false,
      showornot: "password",
      showeye: true,
      equipmentList: [],
      unfoldShow: false,
      showDialog: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.beforeUrl = from.path;
    });
  },

  mounted() {
    this.userdata = JSON.parse(localStorage.getItem("data"));
    this.$nextTick(() => {
      if (this.beforeUrl == "/choiceDevice") {
        this.equipmentList = this.transferEquipmentList;
      } else {
        this.SET_TEANSFEREQUIPMENTLIST([]);
      }
    });
  },
  computed: {
    //数组写法
    ...mapState("common", ["transferEquipmentList"]),
    getDeviceType: {
      get() {
        return function (vipCode, deviceVersionCode, vipName) {
          let item = buyCode.deviceTypeOptions.find(
            (item) => item.vipCode == vipCode || item.vipName == vipName
          );
          if (item) {
            return `${item.vipType}${deviceVersionCode.substring(1)}`;
          } else {
            if (deviceVersionCode) {
              const customVipType =
              vipName.length >= 2 ? vipName.substring(0, 2) : "定制";
              return `${customVipType}${deviceVersionCode.substring(1)}`;
            } else {
              return "";
            }
          }
        };
      },
    },
  },

  methods: {
    ...mapMutations("common", ["SET_TEANSFEREQUIPMENTLIST"]),
    // 获取授权验证码
    async getyanzhengma() {
      let data = {
        mobile: this.userdata.phoneNumber,
        businessType: "equipmentTransfer",
      };
      await getsendCode(data).then((res) => {
        if (res.code == 200) {
          this.yzm_daojishi = true;
          this.startCountDown();
          Toast("验证码已发送至您的手机");
        } else {
          Toast(res.msg);
        }
      });
    },
    // 验证码倒计时
    startCountDown() {
      this.timer = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown--;
        } else {
          clearInterval(this.timer);
          this.yzm_daojishi = false;
          this.countDown = 60;
        }
      }, 1000);
    },
    // 确认授权
    async querenshouquan() {
      if (this.equipmentList.length <= 0) {
        Toast("请选择要转移的设备");
        return;
      }
      const phoneReg = /^1[3456789]\d{9}$/;
      if (!phoneReg.test(this.phone)) {
        Toast("手机号错误！请重新输入");
        return;
      }
      if (this.phone != this.againPhone) {
        Toast("输入的手机号不一致！");
        return;
      }
      if (this.userdata.phoneNumber == this.phone) {
        Toast("不能转移给自己");
        return;
      }
      if (!this.checked) {
        Toast("请阅读并同意《迅流云手机转移协议》");
        return;
      }
      let userInstanceIds = this.equipmentList.map((item) => item.id);
      let data = {
        phoneNumber: this.phone,
        userInstanceIds,
      };

      if (this.Switchlogin) {
        data.code = this.yanzhengma;
        data.transferType = 2;
      } else {
        data.password = this.password;
        data.transferType = 1;
      }
      this.showDialog = true;
      await userEquipmentTransfer(data)
        .then((res) => {
          this.showDialog = false;
          if (res.code == 200) {
            let data = res.data.join(",");
            this.$router.push({
              path: "/transferResults",
              query: { unsuccessful: data },
            });
          }
        })
        .catch((err) => {
          this.showDialog = false;
        });
    },
    toggle(em) {
      this.result = em;
      this.active = em.id;
      this.show = false;
    },
    //密码可见
    isShow() {
      //点击切换眼睛
      this.showeye = !this.showeye;
      if (this.showeye === true) {
        this.showornot = "password";
      } else {
        this.showornot = "text";
      }
    },
    selecteQuipment() {
      this.$router.push({ path: "/choiceDevice" });
    },
  },
};
</script>
  
  <style lang="less" scoped>
.equipmentShift {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.main {
  padding: 10px 16px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  touch-action: manipulation;
  scrollbar-width: none;
  .cardBox {
  }
  .equipmentDetails {
    background: #fff;
    height: 36px;
    padding: 0 12px;
    box-sizing: border-box;
    border-radius: 8px;
    margin-top: -10px;
    position: relative;
    color: #666;
    font-size: 10px;
    position: relative;
    .packUpBox {
      // position: absolute;
      border-top: 1px solid #c6c9d1;
      display: flex;
      justify-content: space-between;
      line-height: 36px;
      .viewAll {
        display: flex;
        align-items: center;
        img {
          width: 7px;
          height: 4px;
          margin-left: 5px;
        }
      }
    }
    .unfoldBox {
      .line {
        background-color: #c6c9d1;
        height: 1px;
        width: 100%;
      }
      position: absolute;
      left: 0;
      width: 343px;
      text-align: left;
      padding: 0 12px;
      box-sizing: border-box;
      background: #fff;
      max-height: 355px;
      overflow-x: hidden;
      overflow-y: auto;
      z-index: 999;
      .unfoldItem {
        height: 35px;
        line-height: 35px;
        border-bottom: 1px solid #e8e9ed;
      }
      .unfoldName {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 35px;
        line-height: 35px;
        font-size: 10px;
        color: #666;
        img {
          width: 7px;
          height: 4px;
          margin-left: 4px;
        }
      }
    }
  }

  .card {
    height: 64px;
    background: #ffffff;
    padding: 0 12px;
    display: flex;
    align-items: center;
    border-radius: 8px;
    p {
      flex: 1;
      text-align: left;
      font-size: 15px;
      color: #303030;
    }
    .no_equipment {
      font-size: 12px;
      color: #666666;
      margin-left: 8px;
      .sp1 {
        color: #ff5719;
      }
    }
    img {
      width: 20px;
      height: 20px;
    }
  }
  .sq_zh {
    margin: 16px 0;
    background: #ffffff;
    padding: 18px 12px;
    border-radius: 10px 10px 10px 10px;
    text-align: left;
    .phoneFrame {
      margin-bottom: 7px;
    }
    .inputBack {
      background-color: #f4f4f4;
      border-radius: 40px;
    }
    .verificationBox {
      // margin-top: 28px;
    }
    .agreementBox {
      // margin-top: 42px;
      /deep/.van-checkbox__label {
        font-size: 14px !important;
        color: #303030 !important;
        margin-left: 5px;
        margin-top: -2px;
        a {
          color: #886df3 !important;
        }
      }
    }
    p {
      margin: 0 0 22px 0;
      font-size: 15px;
    }
    /deep/.van-radio__label--left {
      font-size: 16px;
      color: #303030;
      margin-right: 5px;
    }
    /deep/.van-radio--horizontal {
      margin-right: 30px;
    }
  }
  .sq_gz {
    text-align: left;
    .gz_title {
      font-size: 15px;
      color: #a6a6a6;
      margin: 0 0 14px 0;
    }
    .gz_particulars {
      font-size: 11px;
      color: #a6a6a6;
      p {
        margin: 5px 0;
      }
    }
  }
}
.lilis {
  display: flex;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
  }
  div {
    margin-left: 16px;
    flex: 1;
    text-align: left;
    p {
      margin: 2px 0;
    }
  }
}
.baseBox {
  width: 100%;
  background-color: #fff;
  box-shadow: 0 -1px 8px 0 hsla(0, 0%, 39%, 0.2);
  color: #333;
  margin-left: auto;
  margin-right: auto;
  padding: 8px 0;
  .qdsq_btn {
    width: 90%;
    height: 44px;
    border: none;
    background: #886df3;
    border-radius: 44px;
    font-size: 16px;
    color: #f6f8fb;
    line-height: 23px;
    letter-spacing: 0px;
    text-align: center;
  }
}
/deep/ .van-hairline--top-bottom::after {
  border: none;
}
/deep/.van-cell {
  background: rgba(20, 93, 250, 0.06);
  border-radius: 4px;
}
/deep/.van-field__body {
  height: 30px;
}
</style>